import React, { useEffect } from 'react';
import { Typography, IconButton } from '@material-ui/core';
import Build from '@material-ui/icons/Build';
import Close from '@material-ui/icons/Close';
import Logo from 'assets/images/projectx-logo.png';
import { useHistory } from 'react-router';
import useStyles from './useStyles';

export const MaintenancePage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    document.title = 'ProjectX';
  }, []);

  const handleBackToLogin = () => {
    history.push('/login');
  };

  return (
    <div className={classes.fullPageContainer}>
      <IconButton
        className={classes.backButton}
        onClick={handleBackToLogin}
        aria-label="Back to login"
      >
        <Close />
      </IconButton>

      <div className={classes.content}>
        <Typography className={classes.title}>
          <Build className={classes.emoji} />
          System Under Maintenance
        </Typography>

        <div className={classes.divider} />

        <Typography className={classes.mainMessage}>
          Our team is currently performing updates.
        </Typography>

        <Typography className={classes.subMessage}>
          The system will be available again soon.
        </Typography>

        <div className={classes.logoContainer}>
          <img
            src={Logo}
            alt="Company Logo"
            className={classes.logo}
          />
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
